/* 系統配置相關接口 */
import request from '@/utils/http/request'

//列表
export async function fetchAll({ name, status, pageSize, pageNumber }) {
    return await request.get('/activity', {
        params: {
            name, status, pageSize, pageNumber
        }

    });
}

//運動類型詳情
export async function fetch(id) {
    return await request.get(`/activity/${id}`);
}

//運動類型添加
export async function store({ name, image, status, viewTotal, favoriteTotal, num, amount, author, videoUrl, remark }) {
    return await request.post('/activity', {
        name, image, status, viewTotal, favoriteTotal, num, amount, author, videoUrl, remark
    });
}


export async function update({ id, name, image, status, viewTotal, favoriteTotal, num, amount, author, videoUrl, remark }) {
    return await request.put(`/activity/${id}`, {
        name, image, status, viewTotal, favoriteTotal, num, amount, author, videoUrl, remark
    });
}
//運動類型刪除
export async function destroy(id) {
    return await request.delete(`/activity/${id}`);
}
